import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FinalizedOrcamentoComponent } from './components/finalized-orcamento/finalized-orcamento.component';

@NgModule({
  imports: [CommonModule, MatIconModule, RouterModule],
  declarations: [FinalizedOrcamentoComponent],
  exports: [FinalizedOrcamentoComponent],
})
export class PortalDoVendedorUiFinalizedOrcamentoModule {}
